<template>
  <div class="page_msg container">

    <!-- <div class="airwallex-apple-pay">
      <h1>ApplePayButton integration (Vue 2)</h1>
      <div id="applePayButton"></div>
    </div> -->

    <div class="header_gruop page_width flex_sb">
      <div class="icon_home flex_center" @click="toBack()"><svg t="1729563443244" class="icon" viewBox="0 0 1024 1024"
          version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6080" id="mx_n_1729563443245" width="16" height="16">
          <path
            d="M398.912 513.152l377.28-384.256c27.904-28.416 27.904-74.432 0-102.784-27.84-28.352-73.024-28.352-100.8 0L247.808 461.504C233.792 475.776 226.88 494.464 226.944 513.152 226.88 531.84 233.792 550.464 247.808 564.736l427.584 435.392c27.84 28.352 73.024 28.352 100.8 0 27.904-28.352 27.904-74.368 0-102.656L398.912 513.152z"
            fill="#16181c" p-id="6081"></path>
        </svg></div>
      <div class="header_title">About Us</div>
      <div></div>
    </div>

    <div class="scoller grid_content" :v-infinite-scroll="false" style="overflow:auto">
      <div class="service page_width">

        <p style="font-size: 18px;font-weight: bold;margin-bottom:20px;">About Us</p>
        <p style="margin-bottom:10px;">Rgtplayhub is an established global digital goods and services platform
          for gamers, which provides the best professional game solution for all the gamers. We sell professional and
          affordable Direct Game Top-up. Rgtplayhub aims to provide more and more digital products & services for
          customers. Have fun shopping in rgtplayhub and talk to us via ruiwangtrading@gmail.com, we will
          respond soon.</p>

        <!-- <p style="margin-bottom:10px;">Rgtplayhub aims to provide more and more digital products & services for customers.</p>
            <p>Have fun shopping in rgtplayhub and talk to us via ruiwangtrading@gmail.com , we will respond soon.</p> -->

      </div>
    </div>
  </div>
</template>

<script>
// import uuid from 'uuid';
// const { v4: uuidv4 } = require('uuid');
export default {
  data() {
    return {
      applePayElement: null, // 存储 Apple Pay 元素实例
    };
  },
  mounted() {
    this.initAirwallexApplePay();
    console.log(window.AirwallexComponentsSDK, 555);
  },
  // 组件销毁前清理资源
  beforeDestroy() {
    this.cleanupAirwallex();

  },
  methods: {
    async initAirwallexApplePay() {
      try {
        if (!window.AirwallexComponentsSDK) {
          throw new Error('Airwallex Components SDK 未加载，请先引入对应的 CDN 脚本');
        }

        // 步骤 1：初始化 Airwallex 全局上下文
        await window.AirwallexComponentsSDK.init({
          // env: 'demo',
          env: 'prod', //生产
          enabledElements: ['payments'],
          // enabledElements: ,
        });

        // 步骤 2：创建 Apple Pay 按钮实例
        this.applePayElement = await window.AirwallexComponentsSDK.createElement('applePayButton', {
          intent_id: 'int_hkpdpxbjfhf0kvgvlj6',
          // intent_id: 'int_hkdmwzqfwhezw90yobb',测试
          // client_secret: 'eyJraWQiOiJjNDRjODVkMDliMDc0NmNlYTIwZmI4NjZlYzI4YWY3ZSIsImFsZyI6IkhTMjU2In0.eyJ0eXBlIjoiY2xpZW50LXNlY3JldCIsImFjY291bnRfaWQiOiI5ZjUxMGZhZS1mYjg2LTQyNDMtYmViZi03ZmZjMGE5YzkxNGEiLCJpbnRlbnRfaWQiOiJpbnRfaGtkbXd6cWZ3aGV6dzkweW9iYiIsImJ1c2luZXNzX25hbWUiOiJkZW1vX2h1YW5zaGVuZyIsInBhZGMiOiJISyIsImV4cCI6MTc2ODgzMTM1MCwiaWF0IjoxNzY4ODI3NzUwfQ.bEBVGHBE-QsCu0dCv4LLtFgVbo2vbFVAUpob1_6OJo4',
          client_secret: 'eyJraWQiOiJjZDIwZDA4NGU1OWE0ODg0OWZjYWViNmU3YzVlOWQ2OSIsImFsZyI6IkhTMjU2In0.eyJ0eXBlIjoiY2xpZW50LXNlY3JldCIsImFjY291bnRfaWQiOiJmNTVjNGEzMi1kMDk5LTQ4M2QtODRlZS05YTFiOTAwMmRiOTMiLCJpbnRlbnRfaWQiOiJpbnRfaGtwZHB4YmpmaGYwa3ZndmxqNiIsImJ1c2luZXNzX25hbWUiOiJIdWFuIFNoZW5nIFRyYWRlIExpbWl0ZWQiLCJwYWRjIjoiSEsiLCJleHAiOjE3Njg4ODQ5NTAsImlhdCI6MTc2ODg4MTM1MH0.RbXuO_xIj-xWqhhZ643MaKRwPRTiPucfpBQ9Kju4eCc',
          amount: {
            value: '3.20',
            currency: 'USD',
          },
          // countryCode: 'CN',
          countryCode: 'US',
        });
        
        // requiredBillingContactFields: ['jusn li','2862@163.com']
        // withBilling:true,
        // 步骤 3：挂载按钮
        this.applePayElement.mount('applePayButton');

        // 步骤 4：监听事件
        this.applePayElement.on('ready', (event) => {
          console.log('Apple Pay 按钮就绪：', event.detail);
          alert('Apple Pay 按钮已就绪，可以发起支付');
        });

        this.applePayElement.on('success', (event) => {
          console.log('支付成功：', event.detail);
          alert('支付成功！请处理后续逻辑');
        });

        this.applePayElement.on('error', (event) => {
          console.error('支付异常：', event.detail);
          alert('支付失败，请稍后重试');
        });

      } catch (error) {
        console.error('Airwallex Apple Pay 初始化失败：', error);
        alert(`初始化失败：${error.message}`);
      }
    },
    // 清理资源：避免内存泄漏
    cleanupAirwallex() {
      if (this.applePayElement) {
        this.applePayElement.off('ready');
        this.applePayElement.off('success');
        this.applePayElement.off('error');
        this.applePayElement.destroy();
        this.applePayElement = null;
      }
    },
    // },
    toBack() {
      this.$router.back()
    },
  },
  created() {
    // this.uniqueId = uuid();

    // 2. 生成标准 UUID v4（36 位，含 - 分隔符，标准格式）
    // const standardUuid = uuidv4();
    // console.log('标准 UUID v4 结果：', standardUuid);
  }
}
</script>

<style></style>